import { render, staticRenderFns } from "./PoliciesCharts.vue?vue&type=template&id=3db98b32&scoped=true&"
import script from "./PoliciesCharts.vue?vue&type=script&lang=js&"
export * from "./PoliciesCharts.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesCharts.vue?vue&type=style&index=0&id=3db98b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db98b32",
  null
  
)

export default component.exports